export default __webpack_public_path__ + "static/O0070-bf2cf0a6bbae981a5a4b7b751d4ce556.png";